const ToggleButton = (props) => {
  const { on_click, id, isEnabled, name, itemKey } = props;

  return (
    <div className="">
      <div className="flex">
        <label className="inline-flex relative items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            id={id}
            name={name}
            itemKey={itemKey}
            checked={isEnabled}
            onChange={on_click}
          />
          <div className="w-9 h-5 bg-red-500 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-green-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-green-500"></div>
        </label>
      </div>
    </div>
  );
};

export default ToggleButton;
